import { useEffect, useState } from 'react';
import { getChannelMappings } from '../services/api';
import { mappedChannelPairs } from '../utils/channelMappingRows';

/** Load unique mapped room + CM rate-plan pairs while a rates drawer is open. */
export default function useChannelMappingRows(open) {
  const [mappingPairs, setMappingPairs] = useState([]);
  const [mappingsLoading, setMappingsLoading] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    let cancelled = false;
    setMappingsLoading(true);
    getChannelMappings()
      .then((mappings) => {
        if (!cancelled) setMappingPairs(mappedChannelPairs(mappings));
      })
      .catch(() => {
        if (!cancelled) setMappingPairs([]);
      })
      .finally(() => {
        if (!cancelled) setMappingsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open]);

  return { mappingPairs, mappingsLoading };
}
